<template ref="solutions">
  <section class="g-box">
    <h1 class="u-h1">
      <h2 class="cn animate__flipInY animate__animated animate__slow">多行业解决方案</h2>
      <h4 class="en animate__fadeInUp animate__animated animate__slow">Multi industry solutions</h4>
    </h1>
    <div class="index-solutions-root">
      <ul class="solutions-menu">
        <li v-for="(item,index) in moduleData" :key="index" class="menu-li" :class="{'active':currentNav == index}" @click="chageAcitve(index)" @mouseover="chageAcitve(index)">
          <div class="imgBox">
            <img v-if="currentNav == index" class="iconImg" :src="item.current_icon" alt="">
            <img v-else class="iconImg" :src="item.icon" alt="">
          </div>
          <h5 class="h5">{{ item.title }}</h5>
        </li>
      </ul>
      <ul class="solutions-center">
        <!--    <ul class="solutions-center" :style="{'background':moduleData[currentNav].bgImg}">-->
        <li class="solutions-c-li" v-for="(item,index) in list" :key="index" @click="jumpToHref">
          <h6 class="h6">{{ item.name }}</h6>
          <p class="detail">{{ item.detail }}</p>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
export default {
  name       : 'index-solutions',
  components : {},
  props      : {
    moduleData  : {
      type    : Array,
      default : [],
    },
    animateShow : {
      type    : Boolean,
      default : false,
    },
  },
  data(){
    return {
      currentNav : 0,
    };
  },
  computed   : {
    list(){
      var arr = [];
      if(this.moduleData[this.currentNav]){
        arr = this.moduleData[this.currentNav].list || []
      }
      return arr
    }
  },
  created(){},
  methods    : {
    chageAcitve(index){
      this.currentNav = index;
    },
    jumpToHref(cid = 0){
      location.href = this.$api.domainName + 'products.html' + '?id=' + this.moduleData[this.currentNav].cat_id;
    },
  },
};
</script>
<style scoped lang="scss">
.index-solutions-root{
  display: flex;
  align-items: stretch;
}
.solutions-menu{
  flex: 0 0 214px;
  order: -1;
  $current: #4077ff;
  background: $current;
  .menu-li{
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 20px 10px;
    border-radius: 8px;
    height: 64px;
    width: 194px;
    padding: 0 28px;
    color: #fff;
    @extend %btn_base;
    &.active{
      color: $current;
      background: #fff;
    }
    .h5{
      font-size: 19px;
    }
    .imgBox{
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .iconImg{
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.solutions-center{
  flex: 1;
  background: url("../../assets/solutions-bg0.png");
  background-size: 100% 100%;
  display: flex;
  //align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 70px 54px 0 74px;
  .solutions-c-li{
    border-radius: 5px;
    width: 406px;
    height: 154px;
    padding: 0 22px;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    &:hover{
      background: rgba(14, 119, 255, 0.8);
      box-shadow: 0px 0px 10px 2px rgba(14, 119, 255,0.8);
      color:#fff;
      .h6{
        font-weight: bold;
      }
      .detail{
        color: #fff;
      }
    }
    .h6{
      font-weight: normal;
      font-size: 20px;
    }
    .detail{
      font-size: 16px;
      color: #666;
      @include ellipsis(100%, 3);
      min-height: 90px;
    }
  }
}
</style>
